import { ItemData } from 'core/models/Template'

export const MENU_PRODUCT_CATALOG_TYPE = 'menuProduct' as const

export const MENU_PRODUCT_CATALOG_CONFIG = {
    type: MENU_PRODUCT_CATALOG_TYPE,
    fixedHeader: true,
    isExistRightToolbar: false,
} as const

export type MenuProductSelectedItems = ItemData[]

export type MenuProductCatalogOption = {
    productMenuId: number
    name: string
}

export type MenuProductAdditionalData = {
    productMenus: MenuProductCatalogOption[]
}
